function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.932 167.863C101.789 166.565 89.6176 199.243 60.7654 171.582C42.8587 154.415 55.1226 133.068 52.9557 121.449C50.2222 106.791 28.6326 99.5071 38.4634 76.9357C46.2571 59.0413 59.969 64.027 72.1406 63.4645C89.2494 62.6739 95.879 43.5015 116.432 34.0468C136.986 24.5921 181.982 54.7012 169.917 91.1292C162.531 113.432 194.494 121.095 181.283 150.339C168.072 179.582 148.647 168.983 126.932 167.863Z",
  fill: "#EBEAF9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.7998 60H131.428L154.88 83.4131V165.84H72.7998V60Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.2 82.8H140.53C136.046 82.8 132 78.7544 132 74.2699V59.6L155.2 82.8Z",
  fill: "#320056"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 91.6797,
  y: 108.204,
  width: 12.96,
  height: 2.88,
  rx: 1.44,
  transform: "rotate(-45 91.6797 108.204)",
  fill: "#320056"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 93.7163,
  y: 99.0397,
  width: 12.96,
  height: 2.88,
  rx: 1.44,
  transform: "rotate(45 93.7163 99.0397)",
  fill: "#320056"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 124.8,
  y: 108.204,
  width: 12.96,
  height: 2.88,
  rx: 1.44,
  transform: "rotate(-45 124.8 108.204)",
  fill: "#320056"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 126.836,
  y: 99.0397,
  width: 12.96,
  height: 2.88,
  rx: 1.44,
  transform: "rotate(45 126.836 99.0397)",
  fill: "#320056"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 100.16,
  y: 124.8,
  width: 28.08,
  height: 2.88,
  rx: 1.44,
  fill: "#320056"
});

var SvgErrorPageIcon = function SvgErrorPageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorPageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-page-icon.3080ab08.svg";
export { ForwardRef as ReactComponent };